export default __webpack_public_path__ + "static/anastasiaKitten-a05378d69329631473221d0085cd0324.mp4";